// The Accelerator's Resources page (/accelerator/resources): the home's shelf (Accelerator.dc.html's
// Resources) as a page, with the heading as its h1. src/products/accelerator/Shelf.jsx draws it.
// With nothing placed yet, the shared Resources page's line.
import { Shelf } from '../../products/accelerator/Shelf.jsx'
import '../../styles/accelerator.css'

export default function MastermindResources({ product }) {
  return (
    <Shelf product={product} headingLevel="h1"
      empty={<p className="pp-empty">Nothing here yet. Anything Adam adds for {product.name} shows up here.</p>} />
  )
}
